import { whoAmIResponse } from "@models/project";
import { createContext } from "react";

export interface UserContextType {
    data: whoAmIResponse;
    setUser: (data: whoAmIResponse) => void;

    getCompanyId: () => string;
}

export const UserContext = createContext<whoAmIResponse | null>(null);

// export interface UserContextType {
//     data: whoAmIResponse | null;
//     setUser: (data: whoAmIResponse) => void;
//     getCompanyId: () => string;
// }

// // Initialize with default values
// export const UserContext = createContext<UserContextType>({
//     data: null,
//     setUser: () => {},
//     getCompanyId: () => '',
// });

// export const UserProvider = ({ children }: { children: ReactNode }) => {
//     const [data, setData] = useState<whoAmIResponse | null>(null);

//     const setUser = (newData: whoAmIResponse) => {
//         setData(newData);
//     };

//     const getCompanyId = () => {
//         return data?.company_id || '';
//     };

//     return (
//         <UserContext.Provider value={{ data, setUser, getCompanyId }}>
//             {children}
//         </UserContext.Provider>
//     );
// };
